<template>
  <li class="participant-name-result" :class="statusClass" @click="handleClick">
    <bib-display :bib-number="subject.bib" :color="subject.race?.color" />
    <span class="name">{{ subject.firstName }} {{ subject.lastName }}</span>
    <span v-if="subject.ft" class="finish-time">{{ $fmt.date(subject.ft) }}</span>
  </li>
</template>

<style lang="scss">
.participant-name-result {
  display: grid;
  align-items: center;
  gap: 0rem;
  min-height: 36px;
  padding: 0 0.75rem;
  color: var(--text-color);
  cursor: pointer;
  user-select: none;
  grid-template-columns: 6.5ex 1fr;
  grid-template-rows: 1.5rem 1rem;

  &:hover {
    background: var(--row-hover-bgcolor);
  }

  &.status-DNS {
    color: var(--row-dns-color);
    background: var(--row-dns-bgcolor);

    &:hover { background: var(--row-dns-hover-bgcolor); }
  }

  &.status-DNF,
  &.status-pending-dnf {
    color: var(--row-dnf-color);
    background: var(--row-dnf-bgcolor);

    &:hover { background: var(--row-dnf-hover-bgcolor); }
  }

  &.status-DQ {
    color: var(--row-dq-color);
    background: var(--row-dq-bgcolor);
  }

  .bib-display {
    grid-row: 1/3;
  }
  
  .name {
    flex: 1;  
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    grid-row: 1;
  }

  .finish-time {
    flex: 0 0 auto;
    color: var(--text-dim2-color);
    font-size: 0.875rem;
    grid-row: 2;
    grid-column: 2;
  }
}
</style>

<script>
import { statusToClass } from '@/lib/format.js'

export default {
  props: {
    subject: {
      type: Object,
      required: true
    },
    score: {
      type: Number,
      required: false,
      default: 0,
    }
  },

  emits: ['resultClick'],

  computed: {
    statusClass() {
      return statusToClass(Number(this.subject.status));
    }
  },

  methods: {
    handleClick() {
      this.$emit('resultClick', this.subject);
    }
  }
}
</script>
